// WishlistPage.js
import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Button,
  Grid,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

const WishlistPage = () => {
  const { wishlist, removeFromWishlist, clearWishlist } = useWishlist();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const sanitizePrice = (p) => Number(String(p).replace(/,/g, "")) || 0;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 3 }}>
        ❤️ My Wishlist
      </Typography>

      {/* If empty */}
      {wishlist.length === 0 && (
        <Paper
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: "center",
            width: "100%",
            maxWidth: 500,
            mx: "auto",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Your wishlist is empty.
          </Typography>
          <Button
            variant="contained"
            sx={{ background: "#1a1a19" }}
            onClick={() => navigate("/")}
          >
            Browse Reels
          </Button>
        </Paper>
      )}

      {/* Wishlist items */}
      {wishlist.length > 0 && (
        <>
          <Grid container spacing={3}>
            {wishlist.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    cursor: "pointer",
                  }}
                >
                  <CardMedia
                    component="img"
                    image={item.images?.[0]?.thumbnailUrl }
                    alt={item.title}
                    sx={{ height: 200, objectFit: "cover" }}
                    onClick={() =>
                      navigate(`/product/${item.id}`, {
                        state: { reelIndex: 0 },
                      })
                    }
                  />

                  <CardContent>
                    <Typography variant="h6" fontWeight={700}>
                      {item.title}
                    </Typography>

                    <Typography sx={{ my: 1, fontWeight: 700, color: "#B12704" }}>
                      ₹{Number(item.price || 0).toLocaleString("en-IN")}
                    </Typography>

                    <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                      {/* Add to cart */}
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ background: "#1a1a19", flex: 1 }}
                        onClick={() =>
                          addToCart({
                            id: item.id,
                            title: item.title,
                            price: sanitizePrice(item.price),
                            imageUrl: item.imageUrl,
                            qty: 1,
                          })
                        }
                      >
                        🛒 Add to Cart
                      </Button>

                      {/* Remove */}
                      <IconButton
                        color="error"
                        onClick={() => removeFromWishlist(item.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Clear All */}
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
              variant="outlined"
              color="error"
              onClick={clearWishlist}
              sx={{ borderRadius: 2 }}
            >
              Clear Wishlist
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default WishlistPage;